/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/no-danger */
/* eslint-disable react/prop-types */
import React from 'react';
import { Fade } from 'react-awesome-reveal';

export default function AnimatedContent({ content }) {
  // Validate content prop
  if (!content || typeof content !== 'string') {
    return <div className="prose prose-lg max-w-none">No content available</div>;
  }

  // Split content into sections for staggered animation
  const sections = content.split('<h3>').map((section, index) => {
    if (index === 0) return section;
    return `<h3>${section}`;
  });

  return (
    <div className="prose prose-lg max-w-none prose-invert">
      {sections.map((section, index) => {
        // Create unique key from section content
        const sectionText = section.replace(/<[^>]*>/g, '').substring(0, 50).trim();
        const uniqueKey = `section-${sectionText.replace(/\s+/g, '-').toLowerCase()}`;
        
        return (
          <Fade 
            key={uniqueKey}
            direction="right" 
            duration={1000} 
            delay={300 + (index * 200)}
            className="article-content leading-relaxed"
          >
            <div className="text-white [&>*]:text-white [&>h3]:text-white [&>p]:text-white" dangerouslySetInnerHTML={{ __html: section }} />
          </Fade>
        );
      })}
    </div>
  );
}
